import { Api } from './BaseApi'
import { IPinItem } from '../../types/Pin/IPinItem';

export const PinApi = Api.injectEndpoints({
    endpoints: (builder) => ({
        getPins: builder.query<IPinItem[], void>({
            query: () => 'pin',
            providesTags: ['Pins'],
        }),
        addPin: builder.mutation<any, IPinItem>({
            query: (newPin) => ({
                url: 'pin',
                method: 'POST',
                body: newPin,
            }),
            invalidatesTags: ['Pins'],
        }),
        deletePin: builder.mutation<any, IPinItem>({
            query: (pin) => ({
                url: `pin/${pin.Id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['Pins'],
        }),
        deletePins: builder.mutation<any, undefined>({
            query: (pin) => ({
                url: `pin`,
                method: 'DELETE'
            }),
            invalidatesTags: ['Pins'],
        }),
    }),
});

export const { useGetPinsQuery, useAddPinMutation, useDeletePinMutation } = PinApi;